import axios from 'axios';
import localforage from 'localforage';
// import { clearPrivileges } from 'redux/privileges/actions';
// import { logoutUser, setAccessToken, setCurrentStaffSubjects } from 'redux/users/actions';
import config from 'utils/config';
import { SCHOOL_ID, ACCESS_TOKEN, REFRESH_TOKEN } from 'utils/constants';

const { API_BASE_URL } = config;

const httpClient = axios.create({
  baseURL: API_BASE_URL,
  // headers: {
  //   'X-TENANT-ID': SCHOOL_ID,
  // },
});

const refreshExpiredToken = async (refreshToken) => {
  try {
    const { data } = await httpClient.post(`/token`, { refresh_token: refreshToken });
    await localforage.setItem(ACCESS_TOKEN, data.access_token);
    return data;
  } catch (error) {
    return undefined;
  }
};

let isRefreshingToken = false;

export const instanceInterceptors = async (store) => {
  httpClient.interceptors.response.use(
    (response) => {
      return response;
    },
    async function (error) {
      const originalRequest = error.config;
      const refreshToken = await localforage.getItem(REFRESH_TOKEN);
      if (refreshToken && error.response?.status === 401 && !originalRequest._retry) {
        if (!isRefreshingToken) {
          isRefreshingToken = true;
          originalRequest._retry = true;
          delete httpClient.defaults.headers.common.Authorization;
          const res = await refreshExpiredToken(refreshToken);
          if (res) {
            // store.dispatch(setAccessToken(res.access_token));
            await localforage.setItem(ACCESS_TOKEN, res.access_token);
            isRefreshingToken = false;
            httpClient.defaults.headers.common.Authorization = `Bearer ${res.access_token}`;
            originalRequest.headers.Authorization = `Bearer ${res.access_token}`;
            return httpClient(originalRequest);
          } else {
            // store.dispatch(clearPrivileges());
            // store.dispatch(setCurrentStaffSubjects([]));
            // store.dispatch(logoutUser());
          }
        } else {
          setTimeout(async () => {
            const access_token: any = await localforage.getItem(ACCESS_TOKEN);
            // @ts-ignore
            originalRequest.headers.Authorization = `Bearer ${access_token}`;
            return httpClient(originalRequest);
          }, 2000);
        }
      }
      return Promise.reject(error);
    },
  );
};

export async function httpRequest<T>(request: () => Promise<T>): Promise<T> {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await request();
      resolve(response);
    } catch (error) {
      if (error?.response?.status === 401 || error?.status === 401) {
        const originalRequest = error.response?.config || error.body?.config;
        if (!isRefreshingToken) {
          isRefreshingToken = true;
          const refresh_token = await localforage.getItem(REFRESH_TOKEN);
          delete httpClient.defaults.headers.common.Authorization;
          try {
            const res = await refreshExpiredToken(refresh_token);
            if (res) {
              const { access_token: token } = res;
              await localforage.setItem(ACCESS_TOKEN, token);
              isRefreshingToken = false;
              httpClient.defaults.headers.common.Authorization = `Bearer ${token}`;
              // @ts-ignore
              if (originalRequest.headers) {
                originalRequest.headers.Authorization = `Bearer ${token}`;
                const { data }: any = await axios(originalRequest);
                resolve(data);
              } else {
                const response = await request();
                resolve(response);
              }
            } else {
              reject(error);
            }
          } catch (error2) {
            isRefreshingToken = false;
            reject(error2);
          }
        } else {
          setTimeout(async () => {
            const access_token: any = await localforage.getItem(ACCESS_TOKEN);
            // @ts-ignore
            originalRequest.headers.Authorization = `Bearer ${access_token}`;
            const { data }: any = await axios(originalRequest);
            resolve(data);
          }, 2000);
        }
      } else {
        reject(error);
      }
    }
  });
}

function timeoutPromise<T>(ms: number, promise: Promise<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      const error: any = new Error('We experienced a timeout, please try again.');
      error.name = 'TimeoutError';
      error.response = {
        data: {
          message: 'We experienced a timeout, please try again.',
        },
        status: 409,
      };
      reject(error);
    }, ms);
    promise.then(
      (res) => {
        clearTimeout(timeoutId);
        resolve(res);
      },
      (err) => {
        clearTimeout(timeoutId);
        reject(err);
      },
    );
  });
}

export async function apiWrapper<T>(request: () => Promise<T>) {
  const response = await timeoutPromise(60000, httpRequest(request));
  return response;
}

export const handleAccessToken = async () => {
  const token = await localforage.getItem(ACCESS_TOKEN);
  httpClient.defaults.headers.common.Authorization = token ? `Bearer ${token}` : null;
};

export default httpClient;
